import http from "../../http-common-super-admin";

class UserDataService {
  login(data) {
    return http.post("users/login", data);
  }
  VerifyOtp(data) {
    return http.post("users/verify/otp", data);
  }
  getUserDetail(data) {
    return http.get("/users/detail", data);
  }
  UserList(data) {
    return http.get("/users/list", { params: data });
  }
  ByPassUserLogin(data) {
    return http.post("users/bypass-login", data);
  }
  ChangePassword(data) {
    return http.post("users/change-password", data);
  }
  SyncUsers() {
    return http.post("users/sync/users");
  }
  DbUserDetail(data) {
    return http.get("/users/db-user-detail", { params: data });
  }
  UpdateUserDetail(data) {
    return http.post("/users/db-user-update", data);
  }
  UpdateAdminDetail(data) {
    return http.post("/users/update", data);
  }
  GetSettings(data) {
    return http.get("/users/settings", { params: data });
  }
  superUserList(data) {
    return http.get("/users/superUser/list", { params: data });
  }
  registerUser(data) {
    return http.post("users/superUser/registerUser", data);
  }
  updateMasterUser(data) {
    return http.post("/users/master-user-update", data);
  }
  parentUsersList() {
    return http.get("/users/list/all");
  }
  kidsParentsList(data) {
    return http.get("/users/wingio/parents", { params: data });
  }
  exportWingioParents(data) {
    return http.get("/users/wingio/parents/export", { params: data });
  }
  getParentAuditLogs(data) {
    return http.get("/users/parent/logs", { params: data });
  }
  updateParentTag(data) {
    return http.post("/users/parent/updateTag", data);
  }
  createReviewRequest(data) {
    return http.post("/users/parent/review-request", data);
  }
  getReviewRequestList(data) {
    return http.get("/users/parent/review-request", { params: data });
  }
  getWingioDefaulterParentsList(params) {
    return http.get("users/wingio/parents/defaulter", { params });
  }
  getPaymentErrorList(params) {
    return http.get("users/wingio/payment/errors", { params });
  }
  updateCanReadSMSAndPhoneCall(data) {
    return http.post("users/wingio/parents/update/canReadSMSAndPhoneCall", data);
  }
  kidsParentDetail(data) {
    return http.get("/users/wingio/parent/info", { params: data });
  }
  exportWingioParentEmails(data) {
    return http.get("/users/wingio/parents/export-emails", { params: data });
  }
}

export default new UserDataService();